import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { AppContext } from '@prisjakt/ui-app-context';
import Panel from '@prisjakt/ui-panel';
import PanelHeader from '@prisjakt/ui-panel-header';

import { trackComparisonLinkClick } from '../../../product-compare/tracking';

import { productRelatedClick } from '../../actions/product';

import * as S from './styles';

function RelatedProducts(props) {
  const { t, linkTo } = useContext(AppContext);
  const panelMargin = props.inline ? false : 'bottom';
  const compareUrl = linkTo('productCompare', {
    category: props.category,
    products: props.product
      ? [props.product, ...props.resources.map(x => x.product)]
      : props.resources.map(x => x.product),
  });

  return (
    <Panel
      header={
        <PanelHeader title={t('product', 'related-products.title')}>
          <S.CompareLink
            to={compareUrl}
            rel="nofollow"
            onClick={() => {
              const productCount =
                props.resources.length + (props.product ? 1 : 0);
              trackComparisonLinkClick(productCount, 'similarProducts');
            }}
          >
            {t('product', 'product-compare.compare')}
          </S.CompareLink>
        </PanelHeader>
      }
      margin={panelMargin}
    >
      <S.RelatedProductList>
        {props.resources.map(({ product }, index) => (
          <S.RelatedProductCard
            key={product.id}
            onClick={() => props.productRelatedClick(product, index)}
            name={product.name}
            image={
              product.media && (
                <S.RelatedProductImage
                  name={product.name}
                  src={product.media.first}
                />
              )
            }
            price={product.priceSummary.regular}
            link={product.pathName}
          />
        ))}
      </S.RelatedProductList>
    </Panel>
  );
}

RelatedProducts.defaultProps = {
  resources: [],
  inline: false,
  productRelatedClick: () => {},
  category: undefined,
  product: undefined,
};

RelatedProducts.propTypes = {
  resources: PropTypes.array, // eslint-disable-line react/forbid-prop-types
  inline: PropTypes.bool,
  productRelatedClick: PropTypes.func,
  category: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  product: PropTypes.shape({
    id: PropTypes.number,
  }),
};

export default connect(state => state, { productRelatedClick })(
  memo(RelatedProducts)
);
